import { render, staticRenderFns } from "./CampaignForm.vue?vue&type=template&id=b5096452&scoped=true&"
import script from "./CampaignForm.vue?vue&type=script&lang=js&"
export * from "./CampaignForm.vue?vue&type=script&lang=js&"
import style0 from "./CampaignForm.vue?vue&type=style&index=0&id=b5096452&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5096452",
  null
  
)

export default component.exports